export const getAssignmentQuestionUrl = ({ studentAssignmentId, questionId }) => {
  return `/assignment/${studentAssignmentId}/${questionId}`;
};

export const getAssignmentStartUrl = ({ assignmentId }) => {
  return `/start/${assignmentId}`;
};

export const getAssignmentQuestionURL = ({ studentAssignmentId, questionId }) => {
  return `/assignment/${studentAssignmentId}/${questionId}`;
};

export const getAssignmentEndUrl = ({ studentAssignmentId, reason, showResult }) => {
  const params = new URLSearchParams();
  if (typeof reason === 'string' && reason.trim() !== '') {
    params.set('reason', reason.trim());
  }
  if (showResult) {
    params.set('showResult', '1');
  }
  const query = params.toString();
  const baseUrl = `/assignment/${studentAssignmentId}/end`;
  return query ? `${baseUrl}?${query}` : baseUrl;
};

export const getHomePageUrl = () => {
  return '/';
};

export const getJoinPageUrl = () => {
  return '/join';
};

export const getReviewQuestionUrl = ({ studentAssignmentId, questionId }) => {
  return `/assignment/${studentAssignmentId}/review/${questionId}`;
};

export const getLoginUrl = (redirectUrl) => {
  console.log('redirectUrl', redirectUrl);
  const loginUrl = '/login';
  if (redirectUrl && redirectUrl !== '/') {
    return `${loginUrl}?redirectTo=${redirectUrl}`;
  }
  return loginUrl;
};

export const getPaymentSuccessUrl = (transactionId) => {
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set('upgradeStatus', 'success');
  currentUrl.searchParams.set('transactionId', transactionId);
  return `${currentUrl.pathname}${currentUrl.search}`;
};